export default __webpack_public_path__ + "static/media/medium_icon.5da4274f.svg";